
import React from 'react';

const HammerUnderline = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<g fill="#2d2d2d" clipPath="url(#clip0_2045_2114)">
				<path d="M28.175 10.31l-2-2a.994.994 0 00-.67-.29V8a1 1 0 00-.3-.71s-1.32-1.27-2.02-1.98C22.035 4.16 19.835 3 17.515 3h-.01c-1.71 0-5.99.89-6 2.99 0 .44.28.82.7.95 1.04.33 2.94 1.11 3.59 1.76l.79.79-2.77 2.76-9.16 7.55c-.68.53-1.1 1.32-1.15 2.17-.05.86.26 1.69.87 2.3l.81.81c.56.56 1.33.88 2.12.88.06 0 .12 0 .18-.01.86-.05 1.65-.47 2.16-1.12l7.6-9.18 2.8-2.79c.13.09.27.14.43.14 0 .26.09.52.29.72l2 2c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4-4c.38-.38.38-1.02-.01-1.41zm-10.18.61l.58.59-2.08 2.07-.59-.58 2.09-2.08zm-9.92 12.67c-.18.23-.43.36-.72.38a.973.973 0 01-.76-.29l-.81-.81a.988.988 0 01.12-1.5l8.52-7.03.71.71-7.06 8.54zm15.4-9.98l-.59-.59.29-.29c.38-.38.39-1.01.01-1.4l-.97-1.01a1.01 1.01 0 00-.71-.31c-.29-.02-.53.1-.72.29l-.29.29-3.29-3.3c-.66-.66-1.83-1.25-2.81-1.66.82-.32 2.01-.63 3.1-.63h.01c1.66 0 3.4.87 4.25 1.73.36.36.89.88 1.31 1.29l-.27.28c-.39.38-.39 1.01-.02 1.4l.97 1.01c.19.19.44.31.71.31.25-.03.53-.1.72-.29l.29-.29.59.59-2.58 2.58zM26.475 30.02h-21v2h21v-2z"></path>
			</g>
			<defs>
				<clipPath id="clip0_2045_2114">
					<path fill="#fff" d="M0 0H32V32H0z"></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default HammerUnderline;
